'use client'
import { useState, useContext } from 'react'
import useIsSsr from 'hooks/useIsSsr'
import { useViewportSmallerThan } from 'utils/viewport'
import { BREAKPOINTS } from 'constants/viewport'
import { Phone, X } from 'react-feather'
import { PhoneDataContext } from 'providers/PhoneDataProvider'
import { Box, AchieveTheme } from '@achieve/ascend'
import { Typography } from 'components/Typography'
import { AchieveLink } from 'components/AchieveLink'
import { mainProductConfig } from 'constants/mainProductConfig'

function CtaCallButton({
  children,
  phoneWrapper,
  variant,
  siteEnv = process.env.NEXT_PUBLIC_SITE_ENVIRONMENT || 'achieve',
}) {
  const [buttonCall, setButtonCall] = useState(false)
  const [buttonDisplay, setButtonDisplay] = useState(true)
  const phoneData = useContext(PhoneDataContext)
  const isSsr = useIsSsr()
  const mqHookResults = useViewportSmallerThan(BREAKPOINTS.lg)
  const isMobile = isSsr ? 'true' : mqHookResults

  const getMobileIcon = () => {
    return (
      <Phone
        width={24}
        height={24}
        color={
          variant === 'white'
            ? AchieveTheme?.ascend?.colors?.blue[500]
            : AchieveTheme?.ascend?.colors?.neutral?.[0]
        }
        onClick={handleCall}
      />
    )
  }

  const handleCall = () => {
    if (isMobile && !buttonCall) callToAssociatedNumber()
    setButtonCall(!buttonCall)
    if (!buttonDisplay) {
      setTimeout(() => {
        setButtonDisplay(true)
      }, 200)
    } else {
      setButtonDisplay(false)
    }
  }

  const callToAssociatedNumber = () => {
    if (phoneData?.phoneNumber) window.open(`tel:${phoneData.phoneNumber}`, '_self')
  }

  return phoneWrapper && phoneData?.phoneNumber ? (
    <>
      <div
        className={
          'w-full max-w-full lg:m-0 data-[open-button-call="false"]:flex data-[open-button-call="false"]:justify-center'
        }
        data-open-button-call={buttonCall}
      >
        <div
          className={'w-full lg:w-4/5 [&>span]:[&>a]:text-nowrap'}
          data-open-button-call={buttonCall}
        >
          {buttonDisplay && children}
        </div>
        {phoneData && (
          <Box
            className={
              'flex justify-between items-center cursor-pointer min-h-[48px] ml-6 p-2 rounded-[48px] data-[open-button-call="true"]:overflow-hidden data-[open-button-call="true"]:transition-all data-[open-button-call="true"]:duration-200 data-[open-button-call="true"]:min-w-full data-[open-button-call="true"]:m-0 data-[open-button-call="true"]:px-4 data-[open-button-call="true"]:py-2 data-[open-button-call="true"]:rounded-3xl data-[open-button-call="false"]:justify-center data-[open-button-call="false"]:min-w-[48px] data-[open-button-call="false"]:transition-all data-[open-button-call="false"]:duration-200 data-[open-button-call="false"]:ease-[ease-out] data-[color-variant="white"]:bg-white data-[color-variant="blue"]:bg-blue-500'
            }
            data-open-button-call={buttonCall}
            data-color-variant={variant}
          >
            {/*Empty div to work with space-between*/}
            {buttonCall && <div></div>}
            <div style={{ display: 'flex' }}>
              {!isMobile ? (
                getMobileIcon()
              ) : (
                <AchieveLink
                  className={'w-6 h-6'}
                  target="_self"
                  href={`tel:${phoneData.phoneNumber}`}
                  noLink
                  track={{
                    list_name: 'PHONE CALL CLICK',
                    click_id: phoneData?.phoneNumber,
                    click_text: `${
                      mainProductConfig[siteEnv || 'achieve']?.['MainProductHyphen']
                    } | ${phoneData?.phoneNumber}`,
                    click_url: phoneData?.phoneNumber,
                    click_type: 'Phone Click',
                    nav_link_section: 'Hero',
                    track_event: 'button_click',
                  }}
                >
                  {getMobileIcon()}
                </AchieveLink>
              )}

              {buttonCall && (
                <AchieveLink
                  className={'mx-4 my-0'}
                  href={`tel:${phoneData.phoneNumber}`}
                  target="_self"
                  track={{
                    list_name: 'PHONE CALL CLICK',
                    click_id: phoneData?.phoneNumber,
                    click_text: `${
                      mainProductConfig[siteEnv || 'achieve']?.['MainProductHyphen']
                    } | ${phoneData?.phoneNumber}`,
                    click_url: phoneData?.phoneNumber,
                    click_type: 'Phone Click',
                    nav_link_section: 'Hero',
                    track_event: 'button_click',
                  }}
                >
                  <Typography
                    className={
                      'data-[color-variant="blue"]:text-white data-[color-variant="white"]:text-blue-500'
                    }
                    data-color-variant={variant}
                    variant="bodyLg"
                    fontWeight="regular"
                    onClick={() => callToAssociatedNumber()}
                  >
                    {phoneData?.phoneNumber}
                  </Typography>
                </AchieveLink>
              )}
            </div>
            {buttonCall && (
              <X
                className={''}
                width={18}
                height={18}
                color={AchieveTheme?.ascend?.colors?.neutral?.[3]}
                onClick={handleCall}
              />
            )}
          </Box>
        )}
      </div>
    </>
  ) : (
    <>{children}</>
  )
}

export { CtaCallButton }
